import React from "react";

export function MainLayout({ children }) {
  return <div className="app-layout">{children}</div>;
}